module.exports = __webpack_public_path__ + "d44921a6f3519229ce3b905cc6a69828.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/fotl-t-pink.png
// module id = 833
// module chunks = 0